__webpack_require__.p = "/yuroshopy/vendor/";